/**
 * @module filter
 */

/**
 * Removes all empty entries and entries which are passed as params of an object
 * @param  {object} request
 * @param  {array} deletions
 * @return {object} request
 */

function filterObject(request, deletions = []) {
    for (let i = 0; i < deletions.length; i += 1) {
        delete request[deletions[i]];
    }
    Object.keys(request).forEach((key) => {
        if (request[key] === '' || (request[key] instanceof Array && request[key].length < 1)
            || request[key] === null) {
            delete request[key];
        }
    });

    return request;
}

export { filterObject };
